import React, { useState } from 'react'
 
 
import TaxList from './MRLList';
import TaxForm from './MRLForm';

const MRL= () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
    const [serviceId, setServiceId] = useState("none");
	

  return (
    <>
      {fromIsShown ? (
          <TaxForm addForm={setFromIsShown} update={upData} sId={serviceId}/>
        ) : (
          <TaxList addForm={setFromIsShown} update={setUpData} sId={setServiceId}/>
        )}
  
    </>
  )
}

export default MRL